import {Dispatch} from "react";
import {ActionType} from "../actionTypes";
import {TShelfPromoActions} from "../actions/shelfPromoAction";
import {ErrorDtoFactory} from "../../dtos/errorDto";
import {httpClient} from "../../httpClient";

export const getShelfPromoDetailsDataForPopup = (promoId: number) => {
    return async (dispatch: Dispatch<TShelfPromoActions>) => {
        dispatch({
            type: ActionType.GET_SHELF_PROMO_DETAILS_DATA_START
        })

        try
        {

            let result = await httpClient.get(
                `Promos/GetPromoWithItems?promoId=${promoId}`);
            let data = result.data
            dispatch({
                type: ActionType.GET_SHELF_PROMO_DETAILS_DATA_SUCCESS,
                payload: {
                    ...data,
                    promoId: promoId
                }
            })


            dispatch({
                type: ActionType.GET_SHELF_PROMO_DETAILS_DATA_COMPLETE,
            })
        }
        catch(err){
            dispatch({
                type: ActionType.GET_SHELF_PROMO_DETAILS_DATA_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    };
}

export const toggleShelfPromoDetailsPopup = (isOpen: boolean) => {
    return async (dispatch: Dispatch<TShelfPromoActions>) => {
        dispatch({
            type: ActionType.TOGGLE_SHELF_PROMO_DETAILS_POPUP,
            payload: isOpen
        });
    };
}